export default {
  in: 1,
  out: 2,
};
